import Image from 'app/Components/Shared/Image/image';
import React, {useEffect} from "react";
import BtnWhiteBlackBorderBigSize from "app/Components/Shared/Buttons/BtnWhiteBlackBorderBigSize";
import {prepareUrl} from "app/utilities/StringHelpers/StringHelpers";
import './ResultPage.scss';
import {connect} from "react-redux";
import {
  dwhCannotReplaceSim,
  dwhCannotReplaceSimFinancial,
} from "app/Components/Block/SimReplacementBlock/reports/dwhReports";
import {errors, WHATSAPP_URL} from "app/Components/Block/SimReplacementBlock/simReplacementSlice";
import EpiContext from "@episerver/spa-core/Spa";
import Config from "app/Config";
import ServiceButtons from "app/Components/Shared/ServiceButtons/ServiceButtons";
import {isMobile} from "react-device-detect";
import BtnSubmit from "app/Components/Shared/Buttons/BtnSubmit";


export const ErrorPage = ({props}) => {
  const {debtPaymentLink, updatePaymentLink} = props.iContent;
  useEffect(() => {
    switch (props.simReplacementState?.errorReason) {
      case errors.GENERAL_ERROR:
      case errors.UPDATE_ERROR:
        dwhCannotReplaceSim(props.userData?.loginData?.userDetails?.firstName + " " + props.userData?.loginData.userDetails?.lastName, props.simReplacementState?.subscriber, props.userData?.loginData?.userDetails?.IDNumber, props.simReplacementState?.payload?.userBan);
        break;
      case errors.PROCESS_ERROR:
        dwhCannotReplaceSimFinancial(props.userData?.loginData?.userDetails?.firstName + " " + props.userData?.loginData?.userDetails?.lastName, props.simReplacementState?.subscriber, props.userData?.loginData?.userDetails?.IDNumber, props.simReplacementState?.payload?.userBan);
        break;
      default:
        break;
    }

  }, []);

  const backToHomePage = () => {
    prepareUrl('', props.context)
  }

  const backToLobby = () => {
    EpiContext.navigateTo(Config.lobbyUrl)
  }

  const goToDebtPayment = () => {
    prepareUrl(debtPaymentLink.value, props.context)
  }

  const goToUpdatePaymentMethod = () => {
    prepareUrl(updatePaymentLink.value, props.context)
  }

  function title() {
    switch (props.simReplacementState?.errorReason) {
      case errors.PROCESS_ERROR:
        return (
          <>
            מצטערים, לא ניתן להשלים<br/>
            את הפעולה!
          </>
        );
      case errors.UPDATE_ERROR:
        return (
          <>
            נראה שמשהו השתבש<br/>
            ולא הופעל ה- SIM
          </>
        );
      default:
        return (
          <>
            מצטערים, <br/>
            נראה שמשהו השתבש
          </>
        );
    }
  }

  function repText() {
    console.log(isMobile)
    if (isMobile) {
      return `חייגו ${window.Config.technicalSupportPhone} לנציג שירות`
    } else {
      return `אפשר גם לפנות אלינו ב- ${window.Config.technicalSupportPhone}`
    }
  }

    return (
      <div className={`content ${props.simReplacementState?.errorReason !== errors.PROCESS_ERROR ? 'wide' : ''}`}>
        <div className={'resultPage'}>
          <Image className={'error-image'}
               src={props.simReplacementState?.errorReason === errors.PROCESS_ERROR ? require('../images/collection.svg') : require('../images/error.svg')}
               alt={"error"} />
          <span className={'title'}>
                      {title()}
                  </span>
                {
                  props.simReplacementState?.errorReason === errors.PROCESS_ERROR
                  && (() => {
                    switch (props.simReplacementState?.errorCode) {
                      case 107:
                        return (
                          <span className={'moreInfo'}>
  לפני שנמשיך בתהליך, עליך לעדכן את אמצעי התשלום שלך ב{window.Config.brand_Name_HE} ולשלם את החוב.
                            <span className={'link'} onClick={goToDebtPayment}>לתשלום חוב</span>
                            <span className={'link'} onClick={goToUpdatePaymentMethod}>לעדכון אמצעי תשלום</span>
                      </span>
                        );
                      case 106:
                        return (
                          <span className={'moreInfo'}>
                      לפני שנמשיך בתהליך, עליך לעדכן את אמצעי התשלום שלך {window.Config.brand_Name_HE} .
                      <span className={'link'} onClick={goToUpdatePaymentMethod}>לעדכון אמצעי תשלום</span>
                           </span>
                        );
                      case 105:
                        return (
                          <span className={'moreInfo'}>
                  לפני שנמשיך בתהליך, עליך לשלם את החוב.
                <span className={'link'} onClick={goToDebtPayment}>לתשלום חוב</span>
                      </span>
                        );
                      default:
                        return null;
                    }
                  })()
                }

          {props.simReplacementState?.errorReason !== errors.PROCESS_ERROR && <div className={'support-container'}>
                      <span className={'support-title'}>
                        להשלמת התהליך אפשר<br/>
                        להתקשר אלינו {window.Config.technicalSupportPhone}
                      </span>
          </div>}
          {
            props.simReplacementState?.errorReason === errors.PROCESS_ERROR ?
              <BtnSubmit text={'לאזור האישי'} onclick={backToLobby}/>
              :
              <BtnWhiteBlackBorderBigSize
                text={props.simReplacementState?.errorReason === errors.UPDATE_ERROR ? 'חזרה לאיזור האישי' : 'לעמוד הבית'}
                onclick={props.simReplacementState?.errorReason === errors.UPDATE_ERROR ? backToLobby : backToHomePage}
                />
          }
        </div>
      </div>
    )
}

const mapStateToProps = (state) => {
  return {
    simReplacementState: state.SimReplacement,
    userData: state.userData,
  }
};

const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(ErrorPage);
